import { companyInfo } from '../../../data';

export function Copyright() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="border-t border-gray-300 py-4">
            <p className="text-center text-text-color/70 text-sm font-font-s">
                &copy; {currentYear} {companyInfo.name}. Toate drepturile rezervate.
            </p>
        </div>
    );
}
